{
  "productImageZoomTrigger": {
    "expand": "Zoom imagen"
  },
  "productImageZoomDialog": {
    "close": "Cerrar"
  }
}
